import { render } from "./BoardDeleteModal.vue?vue&type=template&id=66dceb8b&scoped=true"
import script from "./BoardDeleteModal.vue?vue&type=script&lang=js"
export * from "./BoardDeleteModal.vue?vue&type=script&lang=js"

import "./BoardDeleteModal.vue?vue&type=style&index=0&id=66dceb8b&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-66dceb8b"

export default script